import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Spinner, usePageNavigation } from '@shared/components';
import { useWarehouses } from '../../hooks/useWarehouses';
import { WarehousesTable } from '../display/WarehousesTable';

export const Main = () => {
  const { t } = useTranslation('warehouseMapModule');
  const navigate = useNavigate();

  const breadcrumbs = useMemo(() => [{ label: t('title') }], [t]);
  const { data: warehouses, isLoading } = useWarehouses();

  usePageNavigation({ breadcrumbs });

  if (isLoading) {
    return (
      <div className="px-6 pt-4">
        <Spinner />
      </div>
    );
  }

  const warehouseList = warehouses ?? [];

  return (
    <div className="px-6 pt-4">
      <WarehousesTable warehouses={warehouseList} onViewWarehouse={(id) => navigate(`/warehouses/${id}`)} />
    </div>
  );
};
